import React from 'react';

import { Icon } from '@core/js/components/common/Icon';
import { Link } from '@core/js/components/common/Link';

import { useGetGameInfo } from '@interlayer/js/components/common/Game/sun/components/GameInfoBtn/hooks/useGetGameInfo';
import { clsb } from '@interlayer/js/utils/classNames.util';

import style from './GameInfoBtn.scss';

export interface IGameInfoBtnProps {
    code: string;
    gameFeed: string;
    classNames?: Record<string, string>;
}

export const GameInfoBtn: React.FC<IGameInfoBtnProps> = ({ code, gameFeed, classNames }) => {
    const { gameInfoUrl, isGameInfoHidden } = useGetGameInfo({ code, gameFeed });
    const buildCls = clsb([style, classNames]);

    const handlerStopPropagation = (event: React.MouseEvent) => {
        event.stopPropagation();
    };

    if (!gameInfoUrl || isGameInfoHidden) {
        return null;
    }

    return (
        <Link
            aria-hidden
            className={buildCls(['infoBtn'])}
            href={gameInfoUrl.value}
            onClick={handlerStopPropagation}
        >
            <Icon className={buildCls(['icon'])} type="gameInfo" />
        </Link>
    );
};
